import { FC } from "react";
import { Box, Button, Paper, Typography } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { useActionExecutor } from "../../features/guide/useActionExecutor";

interface ConciergeHandoffCardProps {
  actionKey: string;
  /** Admin views show the card exactly as the user sees it, but a click does nothing. */
  preview?: boolean;
}

export const ConciergeHandoffCard: FC<ConciergeHandoffCardProps> = ({
  actionKey,
  preview = false,
}) => {
  const executeAction = useActionExecutor();

  return (
    <Paper
      variant="outlined"
      sx={{
        mt: 1.5,
        px: 1.5,
        py: 1.25,
        borderRadius: 2,
        borderColor: "primary.light",
        bgcolor: "#ffffff",
      }}
    >
      <Typography variant="body2" sx={{ color: "text.primary", fontSize: "0.8125rem" }}>
        AI Concierge opens in its own chat. Attach your file or paste your list there:
        this chat can't take files.
      </Typography>
      <Box sx={{ mt: 1 }}>
        <Button
          variant="contained"
          startIcon={<AutoAwesomeIcon />}
          title={preview ? "Preview: opens AI Concierge for the user" : undefined}
          onClick={() => !preview && executeAction(actionKey)}
        >
          Open AI Concierge
        </Button>
      </Box>
    </Paper>
  );
};
